import { apiServiceProxy } from '../api-proxy';

export type IRating = {
  training_support: string;
  material_product: string;
  disponibility: string;
  awards: string;
  respect: string;
  comment: string;
};

class ShowcaseService {
  public showcaseProfile(producerId: number) {
    return apiServiceProxy.get(`/showcase/profile/${producerId}`);
  }

  public rateProducer(producerId: number, rating: IRating) {
    return apiServiceProxy.post(`/showcase/profile/${producerId}/rate`, rating);
  }
}

export const showCaseService = new ShowcaseService();
